import { PropsWithChildren } from 'react';
import styles from './TitledSection.module.css';
import { SectionTitle } from './SectionTitle';

interface TitledSectionProps extends PropsWithChildren {
  title: string;
}

export const TitledSection = ({ title, children }: TitledSectionProps) => {
  return (
    <div>
      <SectionTitle title={title} />
      <div className={styles.sectionRoot}>{children}</div>
    </div>
  );
};
